import { Alert } from "@/components/ui/alert";
import { ApiError } from "@/lib/api-client";

/**
 * Mất kết nối tới API là lỗi hay gặp nhất lúc phát triển (quên chạy server,
 * server crash). Báo chung chung "không tải được" khiến người dùng đi tìm sai
 * chỗ, nên tách riêng trường hợp này và nói thẳng cần làm gì.
 */
export function ErrorAlert({ error, context }: { error: unknown; context: string }) {
    if (!error) return null;

    if (error instanceof ApiError && error.code === "NETWORK_ERROR") {
        return (
            <Alert tone="danger">
                <p className="font-medium">Không kết nối được máy chủ</p>
                <p className="mt-0.5 text-ink-muted">
                    Máy chủ API không phản hồi. Kiểm tra xem tiến trình đã chạy chưa (
                    <code className="rounded bg-ink/5 px-1 py-0.5 font-mono text-xs">pnpm dev</code>), rồi tải lại
                    trang.
                </p>
            </Alert>
        );
    }

    if (error instanceof ApiError && error.isUnauthorized) {
        return <Alert tone="warning">Phiên đăng nhập đã hết hạn. Tải lại trang để đăng nhập lại.</Alert>;
    }

    return (
        <Alert tone="danger">
            {context}
            {error instanceof Error && `: ${error.message}`}
        </Alert>
    );
}
